import { render, staticRenderFns } from "./WriteToProfessional.vue?vue&type=template&id=1aafd6c8&scoped=true&"
import script from "./WriteToProfessional.vue?vue&type=script&lang=ts&"
export * from "./WriteToProfessional.vue?vue&type=script&lang=ts&"
import style0 from "./WriteToProfessional.vue?vue&type=style&index=0&id=1aafd6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aafd6c8",
  null
  
)

export default component.exports